import { privacyEmail } from "../../../shared/privacy.js";
import { GuestPrivacyActions } from "./guest-privacy-actions.js";
import { privacySections } from "./privacy-content.js";
import "../../styles/more-approved.css";
import "../../styles/privacy.css";
import "../../styles/more-premium.css";

export function PrivacyPage(): React.JSX.Element {
  return (
    <main className="fr-more-page fr-more-page--art fr-privacy-page">
      <a className="fr-privacy-back" href="/more">
        ‹ More
      </a>
      <header>
        <h1>Privacy policy</h1>
        <p className="fr-privacy-date">Updated 12 September 2026</p>
      </header>
      {new URLSearchParams(window.location.search).has("guestClaim") ? (
        <GuestPrivacyActions />
      ) : null}
      <details className="fr-privacy-index">
        <summary>On this page</summary>
        <nav aria-label="Privacy contents" className="fr-privacy-contents">
          {privacySections.map((section) => (
            <a key={section.id} href={`#${section.id}`}>
              {section.title}
            </a>
          ))}
        </nav>
      </details>
      {privacySections.map((section) => (
        <section key={section.id} id={section.id}>
          <h2>{section.title}</h2>
          {section.paragraphs.map((text) => (
            <p key={text}>{text}</p>
          ))}
          {section.links?.map((link) => (
            <p key={link.href}>
              <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            </p>
          ))}
        </section>
      ))}
      <footer>
        <a href={`mailto:${privacyEmail}`}>Contact Ascent Media</a>
        <a
          href="https://www.datatilsynet.no/en/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Datatilsynet
        </a>
      </footer>
    </main>
  );
}
